import React from "react";
import { Building } from "lucide-react";
import SettingsListPanel from "./SettingsListPanel";

const DepartmentManagement = () => (
  <SettingsListPanel
    config={{
      title: "Department Management",
      subtitle: "Manage organization departments and teams",
      icon: Building,
      endpoint: "/api/settings/departments",
      itemLabel: "Department",
      columnLabel: "Department Name",
      placeholder: "Enter department name...",
      checkboxField: {
        key: "allow_shift_swaps",
        label: "Allow shift swaps",
        tooltip:
          "Members of this department can request shift swaps from the Shift Planner. Other departments won't see the option.",
      },
    }}
  />
);

export default DepartmentManagement;
